<template>
  <label class="facet-item-color cursor-pointer flex flex-grow items-center" :for="itemId || item.id" :qaid="qaid">
    <div class="swatch mb-0 mr-1 ml-0" title="color">
      <span class="swatch__decorator" :class="swatchColorClass"></span>
    </div>
    <em>{{ item.displayText }}</em>
  </label>
</template>
<script>
import FacetItemText from './FacetItemText';
export default {
  name: 'FacetItemColor',
  extends: FacetItemText,
  computed: {
    swatchColorClass() {
      return `swatch-${decodeURIComponent(this.item.value).split('|')[0]}`;
    },
  },
};
</script>
